import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class OneColFeature {
    constructor() {
        this.selectors = {
            root: '[data-parallax-cards]'
        };

        this.body = document.body;
        this.rootElem = document.querySelector(this.selectors.root);

        if (!this.rootElem) return;

        this.init();
    }

    parallaxEffect() {
        /*
        gsap.to('.masonry-cards', {
            duration: 0.6,
            transform: 'translateY(-400px)',
            scrollTrigger: {
                trigger: '.masonry-cards',
                start: `${-(window.innerHeight + 200)}px top`,
                end: 'top top',
                scrub: true
                // markers: true,
            }
        });
        */
    }

    init() {
        this.parallaxEffect();
    }
}
